import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Unibrow from 'components/Unibrow';
import TypeIcon from 'components/TypeIcon';

import { unibrow as UnibrowPropType } from 'lib/CustomPropTypes';

import styles from './styles.module.scss';

const TeaseCategory = ({
  defaultSpacing,
  iconUrl,
  size,
  style,
  type,
  unibrow,
  vertical,
}) => {
  const isPaidHub = vertical === 'sponsoredcontent';

  return (
    <Unibrow
      className={classNames(
        styles.eyebrow,
        styles[size],
        'f2 lh-none founders-mono fw1 ttu',
        style,
        {
          'pt4 pb1 ph5 pl4-m': defaultSpacing,
          pr8: ['video', 'slideshow'].includes(type),
          'bg-knockout-primary color-primary': isPaidHub,
        },
      )}
      unibrow={unibrow}
      vertical={vertical}
    >
      <TypeIcon
        type={type}
        url={iconUrl}
        className={styles.typeIcon}
      />
    </Unibrow>
  );
};

TeaseCategory.propTypes = {
  type: PropTypes.string.isRequired,
  unibrow: UnibrowPropType.isRequired,
  defaultSpacing: PropTypes.bool,
  iconUrl: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
  vertical: PropTypes.string,
};

TeaseCategory.defaultProps = {
  defaultSpacing: true,
  iconUrl: '',
  size: 'small',
  style: '',
  vertical: '',
};

export default TeaseCategory;
